export const Z_INDEX_LOW = 1000
export const Z_INDEX_HIGH = 2000
export const Z_INDEX_MAX = 9000
